import React from 'react';
import { useGoogleTranslateLang } from '../../hooks/useGoogleTranslateLang';
import { getSkillDisplayName } from '../../utils/skillTransliteration';

/**
 * SkillLabel
 * - Prevents Google Translate from meaning-translating labour skill names (Painter, Plumber, etc.)
 * - Optionally shows a transliteration based on the currently selected Google Translate language
 */
const SkillLabel = ({ name, className = '', ...rest }) => {
  const lang = useGoogleTranslateLang();
  const display = getSkillDisplayName(name, lang);

  return (
    <span
      className={`notranslate ${className}`.trim()}
      translate="no"
      {...rest}
    >
      {display}
    </span>
  );
};

export default SkillLabel;


